import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'

const Sidebar = () => {

    const location = useLocation();

    const [subPay, setSubPay] = useState(false);

    useEffect(() => {
        if (
            location.pathname === "/admin/bank-management" ||
            location.pathname === "/admin/manage-bank" ||
            location.pathname === "/admin/category-management" ||
            location.pathname === "/admin/manage-category" ||
            location.pathname === "/admin/group-management" ||
            location.pathname === "/admin/manage-group" ||
            location.pathname === "/admin/department-management" ||
            location.pathname === "/admin/manage-department" ||
            location.pathname === "/admin/designation-management" ||
            location.pathname === "/admin/manage-designation" ||
            location.pathname === "/admin/shift-management" ||
            location.pathname === "/admin/manage-shift" ||
            location.pathname === "/admin/authorized-person-management" ||
            location.pathname === "/admin/manage-authorized-person" ||
            location.pathname === '/admin/skill-management' ||
            location.pathname === '/admin/manage-skill' ||
            location.pathname === '/admin/employee-type-management' ||
            location.pathname === '/admin/manage-employee-type'
        ) {
            setSubPay(true);
        }
    }, [location.pathname]);

    const handlePayroll = () => {
        setSubPay(!subPay);
    }

    return (
        <div className="sidebar" id="sidebar">
            <div className="sidebar-inner slimscroll" >
                <div id="sidebar-menu" className="sidebar-menu mt-3">
                    <ul className="sidebar-vertical">

                        <li className={` ${location.pathname === "/admin/dashboard" ? "active" : ""}`}>
                            <Link className="" to="/admin/dashboard"><i className="fa-solid fa-gauge"></i>
                                <span>Dashboard</span></Link>
                        </li>

                        <li className={` ${location.pathname === "/admin/firm-management" ||
                            location.pathname === "/admin/manage-firm"
                            ? "active" : ""}`}>
                            <Link to="/admin/firm-management"><i className="fa-solid fa-building"></i><span>Firm</span></Link>
                        </li>

                        <li className={` ${location.pathname === "/admin/project-management" ||
                            location.pathname === "/admin/manage-project"
                            ? "active" : ""}`}>
                            <Link to="/admin/project-management"><i className="fa-solid fa-briefcase"></i><span>Project / Site</span></Link>
                        </li>

                        <li className={` ${location.pathname === "/admin/year-management" ||
                            location.pathname === "/admin/manage-year"
                            ? "active" : ""}`}>
                            <Link to="/admin/year-management"><i className="fa-solid fa-calendar-days"></i><span>Year</span></Link>
                        </li>

                        <li className={` ${location.pathname === "/admin/user-management" ||
                            location.pathname === "/admin/manage-user"
                            ? "active" : ""}`}>
                            <Link to="/admin/user-management"><i className="fa-solid fa-user"></i><span>User</span></Link>
                        </li>

                        {/* Payroll Master submenu */}
                        <li className="submenu">
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a className={`${subPay === true ? 'subdrop' : ''}`} onClick={handlePayroll} style={{cursor: 'pointer'}}><i className="fa-solid fa-money-bill-transfer"></i><span>Payroll Master</span> <span className="menu-arrow"></span></a>
                            <ul style={{ display: subPay ? 'block' : 'none' }}>
                                <li className={` ${location.pathname === "/admin/bank-management" || location.pathname === "/admin/manage-bank" ? "active" : ""}`}>
                                    <Link to="/admin/bank-management">Bank</Link>
                                </li>
                                <li className={` ${location.pathname === "/admin/category-management" || location.pathname === "/admin/manage-category" ? "active" : ""}`}>
                                    <Link to="/admin/category-management">Category</Link>
                                </li>
                                <li className={` ${location.pathname === "/admin/group-management" || location.pathname === "/admin/manage-group" ? "active" : ""}`}>
                                    <Link to="/admin/group-management">Group</Link>
                                </li>
                                <li className={` ${location.pathname === "/admin/department-management" || location.pathname === "/admin/manage-department" ? "active" : ""}`}>
                                    <Link to="/admin/department-management">Department</Link>
                                </li>
                                <li className={` ${location.pathname === "/admin/designation-management" || location.pathname === "/admin/manage-designation" ? "active" : ""}`}>
                                    <Link to='/admin/designation-management'>Designations</Link>
                                </li>
                                <li className={` ${location.pathname === "/admin/shift-management" || location.pathname === "/admin/manage-shift" ? "active" : ""}`}>
                                    <Link to='/admin/shift-management'>Shift</Link>
                                </li>
                                <li className={` ${location.pathname === "/admin/authorized-person-management" || location.pathname === "/admin/manage-authorized-person" ? "active" : ""}`}>
                                    <Link to='/admin/authorized-person-management'>Auth Person</Link>
                                </li>
                                <li className={` ${location.pathname === "/admin/skill-management" || location.pathname === "/admin/manage-skill" ? "active" : ""}`}>
                                    <Link to='/admin/skill-management'>Skill</Link>
                                </li>
                                <li className={` ${location.pathname === "/admin/employee-type-management" || location.pathname === "/admin/manage-employee-type" ? "active" : ""}`}>
                                    <Link to='/admin/employee-type-management'>Employee Type</Link>
                                </li>
                            </ul>
                        </li>

                        {/* Employee */}
                        <li className={` ${location.pathname === "/admin/employee-management" ||
                            location.pathname === "/admin/manage-employee"
                            ? "active" : ""}`}>
                            <Link to="/admin/employee-management"><i className="fa-solid fa-users"></i><span>Employee</span></Link>
                        </li>

                        {/* Working Day */}
                        <li className={` ${location.pathname === "/admin/work-day-management" ||
                            location.pathname === "/admin/manage-work-day"
                            ? "active" : ""}`}>
                            <Link to="/admin/work-day-management"><i className="fa-solid fa-calendar-check"></i><span>Working Day</span></Link>
                        </li>

                        {/* Salaries */}
                        <li className={` ${location.pathname === "/admin/salary-management" ? "active" : ""}`}>
                            <Link to="/admin/salary-management"><i className="fa-solid fa-dollar-sign"></i><span>Salaries</span></Link>
                        </li>

                        {/* Earning */}
                        <li className={` ${location.pathname === "/admin/earning-management" ||
                            location.pathname === "/admin/manage-earning"
                            ? "active" : ""}`}>
                            <Link to="/admin/earning-management"><i className="fa-solid fa-money-bills"></i><span>Earning</span></Link>
                        </li>

                        {/* Deduction */}
                        <li className={` ${location.pathname === "/admin/deduction-management" ||
                            location.pathname === "/admin/manage-deduction"
                            ? "active" : ""}`}>
                            <Link to="/admin/deduction-management"><i className="fa-solid fa-hand-holding-dollar"></i><span>Deduction</span></Link>
                        </li>

                        {/* Party Bill */}
                        <li className={` ${location.pathname === "/admin/party-bill-management" ||
                            location.pathname === "/admin/manage-party-bill"
                            ? "active" : ""}`}>
                            <Link to="/admin/party-bill-management"><i className="fa-solid fa-file-invoice-dollar"></i><span>Party Bill</span></Link>
                        </li>

                        {/* Loan */}
                        <li className={` ${location.pathname === "/admin/loan-management" ||
                            location.pathname === "/admin/manage-loan"
                            ? "active" : ""}`}>
                            <Link to="/admin/loan-management"><i className="fa-solid fa-piggy-bank"></i><span>Loan Issue</span></Link>
                        </li>

                        {/* Loan Status */}
                        <li className={` ${location.pathname === "/admin/loan-status" ? "active" : ""}`}>
                            <Link to="/admin/loan-status"><i className="fa-solid fa-piggy-bank"></i><span>Loan Ledger</span></Link>
                        </li>

                        {/* Holiday */}
                        <li className={` ${location.pathname === "/admin/holiday-management" ||
                            location.pathname === "/admin/manage-holiday"
                            ? "active" : ""}`}>
                            <Link to="/admin/holiday-management"><i className="fa-solid fa-umbrella-beach"></i><span>Holiday</span></Link>
                        </li>

                    </ul>
                </div>
            </div >
        </div >
    )
}

export default Sidebar
